import { Schema as S } from "effect";
import { UpdateMePayload } from "@pima/web-api";
import { runIntent } from "../run-intent";
import { getClient } from "./client";
import type { User, SelfProfileUpdate } from "@/types/Users";

export async function fetchSessionAccount(): Promise<
  User & { role: string; client_id?: string }
> {
  const client = await getClient();
  const { data } = await runIntent(client.session.getAccount());
  const provider = (["default", "google", "microsoft", "okta"] as const).find(
    (value) => value === data.provider,
  );
  return {
    id: data.id,
    email: data.email,
    role: data.role ?? "",
    language: data.language,
    status: data.status,
    email_notifications: data.email_notifications,
    metadata: { ...data.metadata },
    contract_types: [...data.contract_types],
    ...(data.first_name === null ? {} : { first_name: data.first_name }),
    ...(data.last_name === null ? {} : { last_name: data.last_name }),
    ...(data.title === null ? {} : { title: data.title }),
    ...(data.last_page === null ? {} : { last_page: data.last_page }),
    ...(data.client_id === null ? {} : { client_id: data.client_id }),
    ...(provider ? { provider } : {}),
  };
}

// The caller's own last-visited page — every authenticated persona reads
// and writes this via the session group, never by user id.
export async function updateLastPage(lastPage: string): Promise<void> {
  const client = await getClient();
  await runIntent(
    client.session.updateLastPage({ payload: { last_page: lastPage } }),
  );
}

export async function updateSessionAccount(
  payload: SelfProfileUpdate,
): Promise<void> {
  const client = await getClient();
  await runIntent(
    client.session.updateMe({
      payload: S.decodeUnknownSync(UpdateMePayload)(payload),
    }),
  );
}
